export default __webpack_public_path__ + "static/media/icon.9264cb45.png";